import grade from '../utils/grade-util'
import * as _ from 'lodash'

const resourceKeys = ['author', 'componentTypes', 'grades', 'description', 'standardSets', 'subjects', 'tags', 'title']
/**
 * finds resources that have property values matching the search term
 * @param resources
 * @param searchTerm
 * @returns {[]}
 */
let resolve = (resources, searchTerm, locations) => {
  let results = []
  if (searchTerm === null && locations.length === 0) {
    results = resources
  } else {
    if (searchTerm !== null) {
      results = searchTermResults(searchTerm, resources)
    }
    if (locations !== undefined && locations.length > 0) {
      if (results.length > 0) {
        results = filteredResults(locations, results)
      } else {
        results = filteredResults(locations, resources)
      }
    }
  }
  return results
}

let searchTermResults = (searchTerm, resources) => {
  let results = []
  for (let resource of resources) {
    for (let key in resource) {
      if (resourceKeys.find(k => k === key)) {
        if (key === 'grades') {
          let grades = []
          if (resource[key]) {
            for (let level of resource[key][0].levels) {
              grades.push(grade.resolve(level))
            }
            if (_.includes(grades.toString().toLowerCase(), searchTerm.toLowerCase())) {
              results.push(resource)
              break
            }
          }
        } else {
          if (_.includes(resource[key].toString().toLowerCase(), searchTerm.toLowerCase())) {
            results.push(resource)
            break
          }
        }
      }
    }
  }
  return results
}

let filteredResults = (filters, resources) => {
  let results = []
  filters = filters.map(filter => {
    return filter.title
  })
  for (let resource of resources) {
    for (let key in resource) {
      if (key === 'country') {
        if (_.includes(filters.toString(), resource.country)) {
          results.push(resource)
        }
      }
    }
  }
  return results
}

export default {resolve}
